import styled from 'styled-components';

export const DownloadWrapper = styled.div`
  color: white;
  margin-top: 15px;
`;
export const LoadWrapper = styled.div`
  margin-top: 40px;
  color: white;
`;
export const TitleStyle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: white;
`;
export const TextStyle = styled.div`
  font-size: 16px;
`;
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid white;
  padding-bottom: 2px;
  margin-bottom: 10px;
`;
export const DeleteSVG = styled.div`
  cursor: pointer;
`;
export const NameInput = styled.input`
  all: unset;
  color: white;
  width: 100%;
  padding-top: 5px;
  padding-left: 6px;
  font-size: 16px;
  ::placeholder {
    color: #aaaaaa;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
    transition-delay: 9999s;
  }
  @media screen and (max-width: 768px) {
    margin-left: 0px;
    padding: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 95%;
  }
`;
export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`;
export const ButtonStyle = styled.button`
  border: none;
  height: 32px;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  padding: 2px 5px;
  color: white;
  width: 100%;
  background-color: ${({ eliminar }) => (eliminar ? '#c00000' : '#666666')};
  border-radius: 5px;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;

export const SectionSeparator = styled.div`
  margin: 15px 0;
  width: 100%;
  border-top: 2px solid #666666;
`;
